import React, { useState, useRef } from "react";
import axios from "axios";

/**
 * Maxus catalogue typeahead (Neil 8 Oct spec, Group A1). MAXUS-ONLY, additive.
 * Type a part number (or text); matches come live from the maxuspartsdirect website
 * (GET /api/maxus-catalogue/search). Clicking a result calls onSelect(product) so the
 * parent can add a part line charged like a website order.
 */
export default function MaxusPartSearch({ onSelect, disabled }) {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const timer = useRef(null);

  const doSearch = (value) => {
    if ((value || "").trim().length < 2) {
      setResults([]);
      setOpen(false);
      return;
    }
    setLoading(true);
    axios
      .get("/api/maxus-catalogue/search", { params: { q: value } })
      .then((r) => {
        setResults((r.data && r.data.results) || []);
        setOpen(true);
      })
      .catch(() => {
        setResults([]);
        setOpen(false);
      })
      .finally(() => setLoading(false));
  };

  const onChange = (e) => {
    const v = e.target.value;
    setQ(v);
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => doSearch(v), 300);
  };

  const pick = (item) => {
    if (onSelect) onSelect(item);
    setQ("");
    setResults([]);
    setOpen(false);
  };

  return (
    <div style={{ position: "relative", maxWidth: 560, marginBottom: "0.75rem" }}>
      <label className="label is-small">Add Maxus part from website</label>
      <input
        className="input"
        type="text"
        value={q}
        onChange={onChange}
        disabled={disabled}
        placeholder="Type a part number or name, e.g. C00087683 or headlamp"
        autoComplete="off"
        onFocus={() => { if (results.length) setOpen(true); }}
      />
      {loading && <p className="help">Searching the Maxus website…</p>}
      {open && results.length > 0 && (
        <div
          style={{
            position: "absolute", zIndex: 30, background: "#fff", border: "1px solid #ddd",
            width: "100%", maxHeight: 340, overflowY: "auto",
            boxShadow: "0 4px 10px rgba(0,0,0,0.12)",
          }}
        >
          {results.map((r) => (
            <div
              key={(r.part_number || r.sku) + "-" + r.product_id}
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => pick(r)}
              style={{
                display: "flex", alignItems: "center", gap: 8, padding: "6px 10px",
                cursor: "pointer", borderBottom: "1px solid #f0f0f0",
              }}
            >
              {r.image ? (
                <img src={r.image} alt="" style={{ width: 34, height: 34, objectFit: "contain" }} />
              ) : null}
              <div style={{ flex: 1 }}>
                <strong>{r.part_number}</strong> — {r.name}
                <div style={{ fontSize: 12, color: "#666" }}>
                  £{Number(r.price || 0).toFixed(2)} {r.in_stock ? "· in stock" : "· check stock"}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      {open && !loading && results.length === 0 && (q || "").trim().length >= 2 && (
        <p className="help">No Maxus website matches for “{q}”.</p>
      )}
    </div>
  );
}
